import { IAppFacade } from "../services/app-facade/app-facade.interface";
import { PopoverController, PopoverOptions } from "ionic-angular";
import { Popover } from "ionic-angular/components/popover/popover";

export class PopoverFacade {

    constructor(protected appFacade: IAppFacade, protected popoverController: PopoverController) {

    }

    create(component, data?: {}, opts?: PopoverOptions): Popover {
        return this.popoverController.create(component, data, opts);
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/popover-facade.ts